module.exports = __webpack_public_path__ + "img/icon-services.ff174c5a.svg";